module.exports = __webpack_public_path__ + "img/Camera1.8949570d.png";